import React, { ReactElement } from 'react';

import SheetContainer, { Overlay, Sheet } from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { Label } from '../../../../../../../common/labels/labelTypes';
import LabelEditSheetHeader from './LabelEditSheetHeader';
import LabelEditSheetContent from './LabelEditSheetContent';

type LabelEditSheetProps = {
    label: Label;
    onDeleteClick: () => void;
    sheetProps: UseSheetReturnType;
};

const LabelEditSheet = (props: LabelEditSheetProps): ReactElement => {
    const { label, onDeleteClick, sheetProps } = props;

    return (
        <SheetContainer className="LabelEditSheet color-tool" {...sheetProps}>
            <Overlay />
            <Sheet>
                <LabelEditSheetHeader label={label} sheetProps={sheetProps} />
                <LabelEditSheetContent label={label} onDeleteClick={onDeleteClick} />
            </Sheet>
        </SheetContainer>
    );
};

export default LabelEditSheet;
